var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('v-main',{staticClass:"px-6 mt-4 mb-4",staticStyle:{"min-height":"80vh"}},[_c('router-view',{staticStyle:{"height":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }